import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdvisorConfigKeyFE_HomePanel, AdvisorConfigKeyFE_HPIVarID, ModuleFE_Advisor_AppConfig, ModuleFE_RuntimeFinding } from '@app/advisor-frontend';
import { FindingType_Textual } from '@app/advisor-shared';
import { FadeScrollWrapper } from '@app/styles';
import { _className, AwaitModules, ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray, exists, formatTimestamp, sortArray } from '@nu-art/ts-common';
import './Component_HPI.scss';
import { Component_AdvisorSL_HPI } from '../../../loaders/skeleton/hpi/Component_AdvisorSL_HPI.js';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
const modulesToAwait = [
    ModuleFE_Advisor_AppConfig,
    ModuleFE_RuntimeFinding,
];
const isFindingOfVarIds = (finding, varIds) => {
    return finding.type === FindingType_Textual && varIds.has(finding.variableId);
};
class Component_HPI_Class extends ComponentSync {
    //######################### Life Cycle #########################
    __onRuntimeFindingsUpdated = (...params) => {
        const hpiVarId = AdvisorConfigKeyFE_HPIVarID.get();
        const ccVarId = AdvisorConfigKeyFE_HomePanel.get()?.ccVariableId;
        if (!hpiVarId && !ccVarId)
            return;
        const varIds = new Set([hpiVarId, ccVarId]);
        const findings = asArray(params[1]);
        if (findings.some(finding => isFindingOfVarIds(finding, varIds)))
            this.setState({
                hpiFinding: this.getLatestHPI(),
                ccFinding: this.getLatestCC(),
            });
    };
    deriveStateFromProps(props, state) {
        state.hpiFinding ??= this.getLatestHPI();
        state.ccFinding ??= this.getLatestCC();
        return state;
    }
    componentDidMount() {
        ModuleFE_AdvisorAnalytics.trigger.uiLoad.uiLoad_hpi({
            elapsed_ms: ModuleFE_AdvisorAnalytics.getTimeSinceLoad()
        });
    }
    //######################### Logic #########################
    getLatestHPI() {
        const hpiVarId = AdvisorConfigKeyFE_HPIVarID.get();
        if (!hpiVarId)
            return;
        const varIds = new Set([hpiVarId]);
        const hpiFindings = ModuleFE_RuntimeFinding.cache.filter(f => isFindingOfVarIds(f, varIds));
        return sortArray(hpiFindings, f => f.__created, true)[0];
    }
    getLatestCC() {
        const config = AdvisorConfigKeyFE_HomePanel.get();
        if (!config?.ccVariableId)
            return;
        const varIds = new Set([config.ccVariableId]);
        const findings = ModuleFE_RuntimeFinding.cache.filter(f => isFindingOfVarIds(f, varIds));
        sortArray(findings, f => f.issuedTimestamp, true);
        return findings[0];
    }
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { className: 'c__hpi', children: [this.render_Content(), this.render_Timestamp()] });
    }
    render_Content = () => {
        return _jsx(FadeScrollWrapper, { scrollRef: this.props.scrollRef, children: _jsxs(LL_V_L, { children: [this.render_CC(), this.render_HPI()] }) });
    };
    render_CC = () => {
        if (!this.state.ccFinding)
            return;
        return _jsx("p", { className: 'chief-complaint', children: this.state.ccFinding.value });
    };
    render_HPI = () => {
        const content = this.state.hpiFinding?.value ?? 'No HPI provided';
        const className = _className('hpi', !exists(this.state.hpiFinding) && 'no-hpi');
        return _jsx("p", { className: className, children: content });
    };
    render_Timestamp = () => {
        const ms = Math.max(this.state.hpiFinding?.__created ?? 0, this.state.ccFinding?.__created ?? 0);
        if (!ms)
            return;
        const timestamp = formatTimestamp('hh:mma', ms);
        return _jsxs("div", { className: 'c__hpi__timestamp', children: ["Updated at ", timestamp] });
    };
}
export const Component_HPI = (p) => _jsx(AwaitModules, { modules: modulesToAwait, Component: () => _jsx(Component_HPI_Class, {}), customLoader: Component_AdvisorSL_HPI });
//# sourceMappingURL=Component_HPI.js.map